import { client, gql } from 'data-provider';
import { IUser } from 'interfaces';
import { getRoles } from 'services/role';

export const getUsers = async (searchString = '') => {
  const where = { query: searchString };

  const query = gql`
    query ($where: JSON) {
      users(where: $where) {
        data {
          id
          name
          email
          userCode
          mobileNumber
          role
          platformMemberId
          userPhoto {
            avatar {
              thumbUrl
            }
          }
        }
        keywords
      }
    }
  `;

  const variables = { where };
  const data = await client.request(query, variables);
  return data.users as { data: IUser[]; keywords: string };
};

export const getUsersWithRole = async (searchString = '') => {
  const users = await getUsers(searchString);
  const roles = await getRoles();

  const usersWithRole = {
    data: users.data.map((user) => {
      const role = roles.find((r) => r.id === user.role);
      return { ...user, role };
    }) as IUser[],
    keywords: users.keywords as string,
  };

  return usersWithRole;
};
